import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 660px;
  width: 100%;
  border-radius: 0.75rem;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid rgb(226 232 240);
  overflow: hidden;
`;

export const Header = styled.h4<{ color?: string }>`
  width: 100%;
  background: linear-gradient(135deg, ${({ color }) => color}08 0%, ${({ color }) => color}15 100%);
  border-bottom: 1px solid ${({ color }) => color}20;
  padding: 1.25rem 1.5rem;
  text-align: center;
  font-size: 0.9375rem;
  font-weight: 600;
  color: ${({ color }) => color};
  letter-spacing: -0.01em;
`;

export const ProductItem = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0;
  border-bottom: 1px solid #f1f5f9;
  padding: 0.75rem 1.5rem;
  transition: background-color 0.15s ease;
  
  &:hover {
    background-color: #f8fafc;
  }
  
  &:last-of-type {
    border-bottom: none;
  }
`;

export const ProductDescription = styled.span<{ color?: string }>`
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 400;
`;

export const ProductValue = styled.span<{ color?: string }>`
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
`;

export const Footer = styled.div<{ $borderColor?: string }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  border-top: 1px solid #e2e8f0;
  padding: 1.25rem 1.5rem;
`;

export const TotalValue = styled.span<{ color?: string }>`
  font-weight: 700;
  font-size: 1rem;
  color: ${({ color }) => color};
  letter-spacing: -0.01em;
`;
